import '../../work-orders/parts/work-order-list';
import { entityStore } from '~/utility/BinSentry-ui-utility';
import { LitEntity, SirenActionMixin, html } from '../../utility/lit-entity';

class WorkOrderByState extends SirenActionMixin(LitEntity) {
  static get properties() {
    return {
      fullPath: { type: Boolean, attribute: 'full-path' },
      hideAddress: { type: Boolean, attribute: 'hide-address' },
      historical: { type: Boolean },
      state: { type: String },
      workOrdersHref: { type: String, attribute: false },
    };
  }

  render() {
    const reload = () => entityStore.invalidateHref(this.href);
    return html`
      <work-order-list
        .href="${this.workOrdersHref}"
        hide-state
        ?historical="${this.historical}"
        ?hide-address="${this.hideAddress}"
        ?full-path="${this.fullPath}"
        @response="${reload}"
        @update="${this._onUpdateWorkOrderList}"
      ></work-order-list>
    `;
  }

  _onUpdateWorkOrderList(e) {
    const { detail } = e;
    this.dispatchEvent(new CustomEvent('innerupdate', { detail }));
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    const action = this.entity && this.entity.getAction('filter-work-orders');
    if (!action) {
      return;
    }
    const { url } = this.parseAction(action);
    url.searchParams.delete('type');
    url.searchParams.set('state', this.state);
    this.workOrdersHref = url.href;
    entityStore.invalidateHref(this.workOrdersHref);
  }
}

customElements.define('work-orders-by-state', WorkOrderByState);
